import { gql, useQuery } from "@apollo/client";
import { Select } from "../base/Form";
import useRetryOn429 from "hooks/useRetryOn429";

const FETCH_ODOO_PAYMENT_TERMS = gql`
  query FETCH_ODOO_PAYMENT_TERMS($instance: String, $company: String) {
    odooPaymentTerms(instance: $instance, company: $company)
  }
`;

const OdooPaymentTermsSelector = ({
  instance,
  company,
  value,
  onSelect,
  ...rest
}) => {
  const { loading, error, data, refetch } = useQuery(FETCH_ODOO_PAYMENT_TERMS, {
    variables: { instance, company },
    skip: !company,
  });
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  const odooPaymentTerms = data ? JSON.parse(data.odooPaymentTerms) : [];

  return (
    <Select
      value={value || "0"}
      onChange={(e) => onSelect(e.target.value)}
      {...rest}
    >
      {loading || isAutoRetrying ? (
        <option value="0" disabled>
          loading...
        </option>
      ) : error ? (
        <option value="0" disabled>
          {error.message}
        </option>
      ) : (
        <>
          <option value="0" disabled>
            --- Not Set ---
          </option>
          {odooPaymentTerms.map((i, index) => (
            <option key={index} value={i.id}>
              {i.name}
            </option>
          ))}
        </>
      )}
    </Select>
  );
};

export default OdooPaymentTermsSelector;
